import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import SystemsHeader from '../../components/SystemsHeader';
import SystemsFooter from '../../components/SystemsFooter';
import SeoHead from '../../components/SeoHead';
import LeadForm from '../../components/systems/LeadForm';
import { useSystemsCatalog } from '../../context/SystemsCatalogContext';

export default function CustomBuild() {
  const { slug } = useParams();
  const { getService, loading } = useSystemsCatalog();
  if (loading) return (
    <div className="min-h-screen bg-white"><SystemsHeader /><main className="py-32 text-center text-gray-500">Loading…</main><SystemsFooter /></div>
  );
  const svc = getService(slug);
  if (!svc) return <Navigate to="/systems/solutions" replace />;

  return (
    <div className="min-h-screen bg-white">
      <SeoHead path={`/systems/custom-build/${slug}`} title={`Custom ${svc.name} — ZHELTA Systems`} description={`Get a tailored quote for ${svc.name}.`} />
      <SystemsHeader />
      <main className="py-20 md:py-24">
        <div className="zh-container max-w-3xl">
          <span className="inline-block text-[11px] font-extrabold uppercase tracking-[0.2em] text-[#c9a227]">Custom Build</span>
          <h1 className="mt-4 text-4xl sm:text-5xl font-extrabold tracking-tight text-gray-900 leading-[1.05]">Tailor {svc.name}<br /><span className="text-[#f5a623]">to your exact needs.</span></h1>
          <p className="mt-6 text-[17px] text-gray-600 leading-relaxed">
            Our standard tiers cover most use cases, but if you need something bespoke — volume pricing, custom SLAs, specific integrations, or a hybrid of services — share your requirements below and we&apos;ll come back with a tailored proposal.
          </p>

          <div className="mt-10">
            <LeadForm
              kind="custom-build"
              slug={slug}
              fields={['company', 'phone', 'budget', 'message']}
              ctaLabel="Request custom quote"
              successTitle="Proposal request received"
              testIdPrefix="custom-build"
            />
          </div>
        </div>
      </main>
      <SystemsFooter />
    </div>
  );
}
